export class LootRule {
	rewardLevelMin: number;
	rewardLevelMax: number;
	weaponKey: string;
	ammoMin: number;
	ammoMax: number;
	share: number;

	constructor(
		rewardLevelMin: number,
		rewardLevelMax: number,
		weaponKey: string,
		ammoMin: number,
		ammoMax: number,
		share: number = 1,
	) {
		this.rewardLevelMin = rewardLevelMin;
		this.rewardLevelMax = rewardLevelMax;
		this.weaponKey = weaponKey;
		this.ammoMin = ammoMin;
		this.ammoMax = ammoMax;
		this.share = share;
	}

	isInRange(rewardLevel: number): boolean {
		return rewardLevel >= this.rewardLevelMin && rewardLevel <= this.rewardLevelMax;
	}
}
